import requestService from "@/js/common/Domain/Service/request";
import { getUidMindbox } from "@/js/common/Service/mindboxService";
import { TrackJS } from 'trackjs';
let SubscribeEmailFormView = Backbone.Epoxy.View.extend({
	viewModel: new (Backbone.Model.extend({
		defaults: {
			loading: false,
			EmailWasSend: false,
			$form: null
		}
	}))(),
	bindings: {
		'button': 'classes: { loading: loading }',
		':el': 'classes: { success: EmailWasSend, loading: loading }'
	},
	initialize: function () {
		this.initDOMEvents();

	},
	getTypeBanner() {
		const typesPages = {
			'searchPage': 'sideBanner',
			'atlasPage': 'atlas',
			'main': 'mainpage',
			'railwaySearchPage': 'sideBanner',
		}
		const currentTypePage = window?.appConfig?.pageType;
		const typePage = typesPages[currentTypePage];

		if (!typePage) {
			TrackJS.track('unknown subscribe form');
		}

		return typePage || 'unknown';
	},
	initDOMEvents: function () {
		var self = this;
		setTimeout(function () {
		var	$forms = self.$el.find('form');
			$forms.each(function(i, form) {
				const $form = $(form);
				$form.validate({
					errorElement: 'div',
					rules: {
						email: {
							required: true,
							email: true,
							remote: '/validate/emailValidate'
						}
					},
					messages: {
						email: {
							required: 'Обязательное поле',
							email: 'Неправильный емейл',
							remote: 'Неправильный емейл'
						}
					}
				});
				$form.on('click', 'button', function (e) {
					e.preventDefault();
					e.stopPropagation();
					if ($form.valid() && !self.viewModel.get('loading')) {
						self.viewModel.set('emailError', false);
						self.formSubmit($form.find('input').val());
					}
				});
				self.viewModel.set('$form', $form);
			})
		}, 100);
	},
	formSubmit: function (email) {
		var self = this;
		self.viewModel.set('loading', true);
		requestService({
			type: 'GET',
			url: '/subscriber/add',
			data: {
				email: email,
				context: this.getTypeBanner(),
				mindboxUid: getUidMindbox(),
			}
		}).done(function (data) {
			self.viewModel.set('loading', false);
			if (data && data.success) {
				self.viewModel.set('EmailWasSend', true);
			} else {
				var $form = self.viewModel.get('$form');
				var $validator = $form.validate();
				$validator.showErrors({
					'email': 'Произошла ошибка. Попробуйте использовать другой адрес электронной почты.'
				  });
			}
		}).fail(function () {
			self.viewModel.set('loading', false);
		})
	}
});

export default SubscribeEmailFormView;